import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import IntegratedApp from "./IntegratedApp";
import GuestApp, { isGuestPortalEntry } from "./GuestApp";
import { isIntegratedShellPath } from "./integratedRoute";
import { applyStoredAppearancePreferences } from "./utils/appearancePreferences";
import "./styles.css";
import "./appearance-settings.css";
import "./components/authoritative-home-style.css";
import "./components/authoritative-home-style-product.css";

const isIntegratedShellEntry = isIntegratedShellPath(window.location.pathname);
const isGuestEntry = isGuestPortalEntry(window.location.hostname, window.location.pathname);
applyStoredAppearancePreferences();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isGuestEntry ? <GuestApp /> : isIntegratedShellEntry ? <IntegratedApp /> : <App />}
  </StrictMode>,
);
